import React from 'react';
import PropTypes from 'prop-types';
import styles from './Select.module.scss';
import classNames from 'class-names';

const Select = ({ children, options, selected, name, label, onChange, className, wide }) => (
    <div className={classNames(styles.container, {[styles.wide]: wide}, className)}>
        {label &&
            <label htmlFor={name}>
                {label}
            </label>
        }
        <select name={name} onChange={onChange} value={selected}>
            {children}
            {options.map((item, index) => {
                    const isObject = typeof item === 'object';
                    return (
                        <option value={isObject ? item.name ? item.value : item.name : item}
                                key={index}
                                id={item.id}>
                            {isObject ? item.name ? item.name : item.label : item}
                        </option>
                    )
                }
            )}
        </select>
    </div>
);


Select.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.exact({
                label: PropTypes.string,
                value: PropTypes.any
            }),
            PropTypes.exact({
                name: PropTypes.string,
                value: PropTypes.any
            })
        ])),
    selected: PropTypes.oneOfType([
        PropTypes.exact({
            label: PropTypes.string,
            value: PropTypes.any
        }),
        PropTypes.string
    ]),
    name: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    key: PropTypes.number,
};

export default Select;
